import axios from "axios";

// app
import app from "../config/app";

let headers = {};
const axiosUpload = axios.create({
  baseURL: app.baseURL,
  headers,
});

axiosUpload.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("@serial");
    if (token) {
      config.headers.Authorization = "bearer " + token;
    }
    config.headers.Accept = "application/json";
    // Don't set Content-Type for FormData - let axios handle it automatically
    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "multipart/form-data";
    }

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

axiosUpload.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    if (
      error.response.status === 401 &&
      window.location.pathname !== "/login"
    ) {
      window.location.href = "/login";
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }
);
export default axiosUpload;
